import { useGetDatasource } from "hooks/useMasterData";
import styled from "@emotion/styled";
import { Col, Form, Row, Select } from "antd";
import { FC, useRef } from "react";

const { Option } = Select;

const DATASOURCE_KEYS_EXCLUDED_FROM_SELECT = new Set([
  "application_bangbow",
  "app_agent",
  "app_retail",
  "ecommerce_web",
]);

interface MainOrderDatasourceProps {
  form: any; // รับ form instance จากฟอร์มหลัก
  datasourceRef?: React.RefObject<any>;
}

const MainOrderDatasource: FC<MainOrderDatasourceProps> = ({
  form,
  datasourceRef,
}) => {
  const { data: masterDatasource } = useGetDatasource();

  const childrenDatasource: React.ReactNode[] = [];
  childrenDatasource.push(
    <Option key="default">เลือกช่องทางการสั่งซื้อ</Option>
  );
  masterDatasource
    ?.filter((item) => !DATASOURCE_KEYS_EXCLUDED_FROM_SELECT.has(item.key))
    .map((item) => {
      return childrenDatasource.push(
        <Option key={item.key} value={item.key}>
          {item.name}
        </Option>
      );
    });

  return (
    <>
      <FormWrapper>
        <Row style={{ backgroundColor: "#EFEFEFEF" }}>
          <Col span={24}>
            <FormWrapper>
              <FormItems
                label="ช่องทางการสั่งซื้อ"
                name="datasource"
                style={{ fontWeight: "400", marginLeft: "5px" }}
                rules={[
                  { required: true, message: "กรุณาช่องทางการสั่งซื้อ" },
                ]}>
                <Select
                  placeholder="ช่องทางการสั่งซื้อ"
                  optionFilterProp="children"
                  ref={datasourceRef}>
                  {childrenDatasource}
                </Select>
              </FormItems>
            </FormWrapper>
          </Col>
        </Row>
      </FormWrapper>
    </>
  );
};

export default MainOrderDatasource;

const FormItems = styled(Form.Item)`
  margin-bottom: 10px;
  width: 300px;
`;
const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10x;
  background-color: #ffffffff;
`;
